import { CompanyModel, CompanyType } from 'models/CompanyModel';

export enum AuthState {
    Loading,
    Guest,
    User,
}

export type AuthModel = {
    id: string,
    lastName: string,
    firstName: string,
    email: string,
    phone?: string,
    roles: string[],
    permissions: Set<string>,
    type: CompanyType,
    state: AuthState,
    company: CompanyModel,
    managedPartyId?: number,
    settings: {
        locale: string,
        'mailings.car_added': string,
        'mailings.car_photos_added': string,
        'mailings.car_fill_reminder': string,
        'mailings.freight_reminder': string,
        'mailings.vessel_departed': string,
    }
}
